import { Map } from 'immutable';
import { DATA } from '@constants/actions';

const initialState = Map({
  orgList: []
});

const Data = (state = initialState, action) => {
  const actionPayload = action.payload;
  switch (action.type) {
    case DATA.ORG_POPULATE:
      return state.set('orgList', actionPayload.orgList);
    default:
      return state;
  }
};

export default Data;